import { IconHighlightedSizeType } from '@kubit/web-ui-components/iconHighlighted/types';
import { StackableCardVariantType } from '../../../../../components/stackableCard/types/stackableCardVariantType';
import { FONT_WEIGHT } from '../../foundations/typography';
import { TagVariantType, TextVariantType } from '../variants';
export const getStackableCardStyles = (FOUNDATIONS, FONT) => {
    return {
        [StackableCardVariantType.DEFAULT]: {
            rootContainer: {
                display: 'flex',
                flex_direction: 'row',
                width: '100%',
            },
            actionContainer: {
                flex: 1,
                display: 'flex',
                flex_direction: 'row',
                padding: FOUNDATIONS.spacing_150,
                align_items: 'flex-start',
                gap: FOUNDATIONS.spacing_150,
                background_color: FOUNDATIONS.color_neutral_bg_375,
                overflow: 'hidden',
                cursor: 'pointer',
            },
            iconHighlighted: {
                size: IconHighlightedSizeType.EXTRA_SMALL,
            },
            infoContainer: {
                flex: 1,
                display: 'flex',
                flex_direction: 'column',
                justify_content: 'center',
                align_items: 'flex-start',
                gap: FOUNDATIONS.spacing_100,
                min_width: FOUNDATIONS.spacing_450,
                overflow: 'hidden',
                word_break: 'break-word',
            },
            title: {
                font_variant: TextVariantType.FONT_PARAGRAPH_250,
                font_weight: FONT_WEIGHT.font_weight_600,
                color: FOUNDATIONS.color_neutral_font_50,
                text_align: 'left',
            },
            conceptAlias: {
                font_variant: TextVariantType.FONT_PARAGRAPH_200,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_neutral_font_50,
                text_align: 'left',
            },
            secondaryInfo: {
                font_variant: TextVariantType.FONT_PARAGRAPH_500,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_neutral_font_50,
                text_align: 'left',
            },
            tag: {
                variant: TagVariantType.NEUTRAL,
            },
            amountDetailNumberContainer: {
                display: 'flex',
                flex_direction: 'column',
                justify_content: 'center',
                align_items: 'flex-end',
                gap: FOUNDATIONS.spacing_100,
                overflow: 'hidden',
                word_break: 'break-word',
                min_width: FOUNDATIONS.spacing_250,
            },
            amount: {
                font_variant: TextVariantType.FONT_PARAGRAPH_250,
                font_weight: FONT_WEIGHT.font_weight_600,
                color: FOUNDATIONS.color_neutral_font_50,
                blur: `blur(${FOUNDATIONS.blur_50})`,
                text_align: 'right',
            },
            detailNumber: {
                font_variant: TextVariantType.FONT_PARAGRAPH_500,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_neutral_font_50,
                blur: `blur(${FOUNDATIONS.blur_50})`,
                text_align: 'right',
            },
            detailNumberV2: {
                font_weight: FONT_WEIGHT.font_regular,
                font_variant: TextVariantType.FONT_PARAGRAPH_500,
            },
            subAmountMask: {
                font_weight: FONT_WEIGHT.font_regular,
                font_variant: TextVariantType.FONT_PARAGRAPH_200,
            },
            extraActionContainer: {
                max_width: FOUNDATIONS.spacing_600,
                display: 'flex',
                align_items: 'center',
                justify_content: 'center',
                padding_top: FOUNDATIONS.spacing_150,
                padding_bottom: FOUNDATIONS.spacing_150,
                padding_left: FOUNDATIONS.spacing_250,
                padding_right: FOUNDATIONS.spacing_250,
                background_color: FOUNDATIONS.color_feedback_info_bg_100,
                border_top_right_radius: FOUNDATIONS.radius_100,
                border_bottom_right_radius: FOUNDATIONS.radius_100,
                cursor: 'pointer',
            },
            extraActionTitle: {
                font_variant: TextVariantType.FONT_PARAGRAPH_350,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_neutral_font_onsurface_100,
                text_align: 'left',
            },
        },
    };
};
//# sourceMappingURL=styles.js.map